import React, {useRef, useState} from 'react';
import { useOutsiderDetector } from '../../Hooks/useOutsiderDetector';
import { ButtonSize } from '../../Data/Enums/Generic';
import { ColourMod } from '../../Data/Enums/LayoutEnums';
import Button from '../Buttons/Button';
import {NestedDropdownMenuType} from "./DropdownMenuTypes";

const NestedDropdownMenu = (props: NestedDropdownMenuType) => {
	const [open, setOpen] = useState<boolean>(false);

	const menuRef = useRef(null);

	const manualOpen = (state?: boolean) => {
		if (props.opensOnHover) return;
		setOpen(state ?? !open);
	};

	useOutsiderDetector(menuRef, () => open ? manualOpen(false) : null);

	return (
		<div
			ref={menuRef}
			className={`item-menu-control-wrapper ${!!props.opensOnHover ? 'open-on-hover' : ''} ${open ? 'child-menu-open' : ''} ${props.dynamicWidth ? 'dynamic-width' : ''}
			${ props.fromEnd ? 'from-end' : '' } ${ props.fromBottom ? 'from-bottom' : '' } nonDraggable`}
			style={props.style}
		>
			{!props.customTrigger && (
				<Button
					raised={true}
					showArrow={true}
					colour={ColourMod.Text}
					size={props.triggerSize ?? ButtonSize.Default}
					title={props.title ?? '-'}
					onClick={(e) => manualOpen()}
					style={{ width: '100%' }}
					squared={true}
				/>
			)}

			{props.customTrigger && (
				<div className='item-menu-custom-trigger custommmm' onClick={(e) => manualOpen()}>
					{props.customTrigger}
				</div>
			)}

			<div className='item-menu-container nonDraggable'>
				{props.children}
			</div>
		</div>
	);
};

export default NestedDropdownMenu;
